import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { d as defineCustomElement$7 } from './p-BedvZv52.js';
import { d as defineCustomElement$6 } from './p-D-k_i6-R.js';
import { d as defineCustomElement$5 } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$4 } from './p-BVCTlSQE.js';
import { d as defineCustomElement$3 } from './p-DaiIyqo3.js';
import { d as defineCustomElement$2 } from './p-Bjt5CD4D.js';
import { d as defineCustomElement$1 } from './p-QtR5VUMp.js';

var TablePageLength;
(function (TablePageLength) {
    TablePageLength[TablePageLength["s"] = 10] = "s";
    TablePageLength[TablePageLength["m"] = 25] = "m";
    TablePageLength[TablePageLength["l"] = 50] = "l";
})(TablePageLength || (TablePageLength = {}));
var TablePaginationMode;
(function (TablePaginationMode) {
    /**
     * Pagination is never rendered.
     *
     * The page length can not be set, and the table will render as many rows as possible.
     */
    TablePaginationMode["off"] = "off";
    /**
     * Pagination will render automatically.
     *
     * It will start out hidden and appear when a total length exceeds the page length. If a new total length falls
     * below the page length later on, the pagination will be disabled instead of switching back to hidden.
     */
    TablePaginationMode["auto"] = "auto";
})(TablePaginationMode || (TablePaginationMode = {}));

const tablePageLengthInputCss = ":host{align-items:center;color:var(--jw-theme-surface-text-description-color);display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.75rem;letter-spacing:-.0004em;line-height:1.25rem}:host hr{border-color:var(--jw-theme-surface-divider-color);border-style:solid;border-width:1px;border-bottom:0;border-left:0;flex:none;margin:0;padding:0}:host span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";

const WuiTablePageLengthInput = /*@__PURE__*/ proxyCustomElement(class WuiTablePageLengthInput extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.changePageLength = createEvent(this, "changePageLength", 3);
        this.pageLength = TablePageLength.s;
        this.page = 1;
        this.total = 0;
    }
    render() {
        const isCustomPageLength = !this.pageLengths?.includes(this.pageLength);
        const start = this.page * this.pageLength - this.pageLength;
        const end = Math.min(start + this.pageLength, this.total);
        return (h(Host, { key: '606d792d2dc6e0923816fb441da4c280453993aa' }, !isCustomPageLength && (h(Fragment, { key: 'b1703ea13c66818d9b9072544307818faf55ed26' }, h("span", { key: '2a9cde7bc47d984e5a4d6e3fb3e13ef706bddc84', class: "label" }, "Results per page"), h("wui-layout", { key: 'fa197b66b7ea28c54b443c3e1f074531ea918732', type: "button-group", variant: "button-group-tight" }, this.pageLengths?.map((pageLength) => {
            return (h("wui-button", { key: String(pageLength), type: "ghost", label: String(pageLength), toggled: pageLength === this.pageLength, disabled: this.disabled || pageLength === this.pageLength, onClick: () => {
                    this.changePageLength.emit(pageLength);
                } }));
        })), h("wui-divider", { key: '583a2297147d9339cec0e5406ed9f19689b202da', type: "vertical" }))), h("span", { key: '50d942f4a1cfe37ff0c5a7545b8fe4685a1bf2a4' }, "Showing ", start + 1, " - ", end, " of ", this.total === Number.POSITIVE_INFINITY ? '∞' : this.total, " items")));
    }
    static get style() { return tablePageLengthInputCss; }
}, [257, "wui-table-page-length-input", {
        "pageLength": [2, "page-length"],
        "pageLengths": [16, "page-lengths"],
        "page": [2],
        "total": [2],
        "disabled": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-table-page-length-input", "wui-button", "wui-divider", "wui-icon", "wui-layout", "wui-loader", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-table-page-length-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTablePageLengthInput);
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-layout":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { TablePageLength as T, WuiTablePageLengthInput as W, defineCustomElement as d };
